import { defineStore } from 'pinia';
import { fetchOfflineDevices, fetchStructures } from '@/api';

export default defineStore({
  id: 'devices',

  state: () => ({
    list: [],
    listPage: {},
  }),

  getters: {},

  actions: {
    async getOfflineDevicesList(parentId, filters = {}) {
      const params = { parentId, recursive: true, ...filters };
      const { structures, meta } = await fetchStructures(params);

      this.list = [];
      structures.structures.forEach((element) => {
        let structuresDevices = element.type.value.devices;
        structuresDevices.forEach((device) => {
          device.structureId = element.type.value.structureId;
          device.resident = element.type.value.resident;
          device.appartment = element.type.value.label;
          this.list.push(device);
        });
      });
    },
  },
});
